import { CloseButton, MDBox, MDButton, MDTypography } from '@components';
import {
  CANCEL_REFRESH_DATA,
  CLICKED_REFRESH_DATA
} from '@constants/eventNames';
import { Dialog, DialogContent } from '@mui/material';
import { RootState } from '@store/store';
import { sendAmplitudeData } from '@utils/amplitude';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

interface RefreshDataModalProps {
  lastUpdatedTimestamp: string;
  planName: string;
  sheetName: string;
  handleRefreshClick: () => void;
  onClose: () => void;
}

const RefreshDataModal: React.FC<RefreshDataModalProps> = ({
  lastUpdatedTimestamp,
  planName,
  handleRefreshClick,
  onClose
}) => {
  const userDetails = useSelector((state: RootState) => state?.userDetails);

  useEffect(() => {
    sendAmplitudeData(CLICKED_REFRESH_DATA);
  }, []);

  const handleCancelClick = () => {
    sendAmplitudeData(CANCEL_REFRESH_DATA);
    onClose();
  };

  return (
    <Dialog
      open
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          width: '710px',
          maxWidth: '800px',
          position: 'relative',
          paddingY: 2,
          paddingX: 1,
          overflow: 'visible'
        }
      }}
    >
      <CloseButton onClose={() => onClose()} />
      <DialogContent>
        <MDBox mb={2}>
          <MDTypography variant='h3' color='secondary' textGradient>
            Are you sure you want to update data?
          </MDTypography>
          <MDBox mt={1.5}>
            <MDTypography variant='sm'>
              Number of updates left under {planName} plan:{' '}
              {userDetails?.data_updates_remaining}
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox
          display='flex'
          width='100%'
          justifyContent='center'
          gap={3}
          mb={2}
        >
          <MDButton
            color='secondary'
            variant='outlined'
            onClick={handleCancelClick}
          >
            Cancel
          </MDButton>
          <MDButton
            color='primary'
            variant='gradient'
            onClick={handleRefreshClick}
          >
            Yes, update my data!
          </MDButton>
        </MDBox>
        <MDBox sx={{ textAlign: 'left', ml: 2 }}>
          <ul>
            <li>
              <MDTypography variant='sm'>
                This feature automatically adds new rows since the last update
                on {lastUpdatedTimestamp} , and updates all charts with the new
                data.
              </MDTypography>
            </li>
            <li>
              <MDTypography variant='sm'>
                We recommend not changing the sheet name in your Google Sheet,
                as it may cause update errors.
              </MDTypography>
            </li>
          </ul>
        </MDBox>
      </DialogContent>
    </Dialog>
  );
};

export default RefreshDataModal;
